module.exports = __webpack_public_path__ + "static/media/hero-cpg.2aad877d.png";